import React from "react";
import { Button, Grid, Modal } from "@mui/material";
import { Box } from "@mui/system";
import ButtonLoader from "../../ButtonLoader";

const ResolveReportModal = ({
  modalOpen,
  handleClose,
  modalStyle,
  handleConfirm,
  loading,
}) => {
  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box sx={modalStyle}>
        <span style={{ color: "#313137", fontSize: 20, fontWeight: 600 }}>
          Resolve Report
        </span>
        <Grid container>
          <span style={messageText}>
            Are you sure you want to resolve this report?
          </span>
        </Grid>
        <Grid container>
          {loading ? (
            <Grid container style={{ width: "50%" }} justifyContent="center">
              <ButtonLoader />
            </Grid>
          ) : (
            <Button
              fullWidth
              variant="contained"
              onClick={handleConfirm}
              style={confirmButton}
            >
              Yes, I confirm
            </Button>
          )}
          <Button
            fullWidth
            variant="outlined"
            onClick={handleClose}
            style={cancelButton}
          >
            No
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ResolveReportModal;

const cancelButton = {
  width: "130px",
  marginLeft: "auto",
  height: 55,
  fontSize: 15,
  fontWeight: 600,
  color: "#313137",
  borderColor: "#313137",
  textTransform: "none",
};

const confirmButton = {
  width: "200px",
  textTransform: "none",
  height: 55,
  fontSize: 15,
  fontWeight: 600,
  background: "#C84B96",
  color: "#FFFFFF",
};

const messageText = {
  color: "#000000",
  fontSize: 15,
  fontWeight: 500,
  marginTop: 30,
  marginBottom: 30,
};
